const WindowLabel = ({ label }) => {
  if (!label) return null;

  return (
    <span
      className="inline-flex items-center h-[22px] px-2 rounded-full bg-[#F6F6F9] text-[#8185A8] text-[11px] font-semibold whitespace-nowrap"
      style={{ fontFamily: "Inter" }}
    >
      {label}
    </span>
  );
};

export default WindowLabel;
